import { useStoreSelector } from '../../../../core/store/selector.js';
import { PieChartStateContext } from '../../context/PieChartStateContext.js';
import { PieChartState } from '../../types/state.js';

export const useSelector = <T>(selector: (state: PieChartState) => T): T =>
  useStoreSelector(PieChartStateContext, selector);
